import BMap from 'BMap'
import router from '../router'
// import utils from '@/js/utils'

export default {
  getCurrentLocation: function (callback) {
    var geolocationControl = new BMap.Geolocation()
    geolocationControl.getCurrentPosition(function (r) {

      if (this.getStatus() == BMAP_STATUS_SUCCESS) {

        var address = {}
        address.province = r.address.province
        address.city = r.address.city
        address.district = r.address.district
        address.street = r.address.street
        address.streetNumber = r.address.street_number
        address.latitude = r.latitude
        address.longitude = r.longitude
        callback(address)
      }
      else {
        router.push('/chooseCity')
      }

    })
  },
  getLoaclLocation: function(callback) {
    var myGeo = new BMap.Geocoder();
    var localAddress = JSON.parse(localStorage.getItem('locationCity'));
  console.log(localAddress)

    if(!localAddress) router.push('/chooseCity');
    myGeo.getPoint(localAddress.cityName, function(point){

        var address = {}
        address.province = localAddress.provinceName;
        address.city = localAddress.cityName;
        address.district = localAddress.regionName;
        address.latitude = point.lat;
        address.longitude = point.lng;
        callback(address)
    },JSON.parse(localStorage.getItem('locationCity')).cityName);
  }
}



// WEBPACK FOOTER //
// ./src/js/mapHelper.js